import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setShowMessage } from "../../../redux/slices/notificationSlice";
import { Button } from "react-bootstrap"; // Assuming Button is imported from react-bootstrap
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from "react-bootstrap";
import "../../../styles/customfield.css"
import translations from "../../../assets/locals/translations";
const CustomField = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];

  const [customFields, setCustomFields] = useState([{ label: "", field: "" }]);
  const [mainFieldList, setMainFieldList] = useState([]);
  const [allowCustomField, setAllowCustomField] = useState(false);
  const [parentField, setParentField] = useState();
  const [customField, setCustomField] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [treedataList, setTreedataList] = useState([]);
  const [mainparentField, setMainparentField] = useState();
  const [CustomFieldTypeMain, setCustomFieldTypeMain] = useState(0);
  const addCustomField = () => {
    setCustomFields([...customFields, { label: "", field: "" }]);
  };

  const removeCustomField = (indexToRemove) => {
    const updatedFields = customFields.filter(
      (_, index) => index !== indexToRemove
    );
    setCustomFields(updatedFields);
  };

  const handleCustomFieldChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFields = [...customFields];
    updatedFields[index][name] = value;
    setCustomFields(updatedFields);
  };

  const handleSubmit = () => {
    const newurl = `${process.env.REACT_APP_NODE_URL}/api/master/add-custom-field`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    Axios.post(newurl, { fields: customFields }, config)
      .then((response) => {
        if (response && response.data.isSuccess) {
          console.log(response.data.result, "add-custom-field");
          setCustomFields(response.data.result);
          dispatch(setShowMessage(t.fieldcreated || "Field Created"));
          setCustomFields([{ label: "", field: "" }]);
        }
      })
  };

  async function getMainField() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/get-category_main_field-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setMainFieldList(response.data.result);
        }
      }
    });
  }
  const HandleChangeParentField = (e) => {
    setAllowCustomField(true);
    setParentField(e.target.value);
    setErrorMessage('')
  }
  const SubmitHandler = () => {
    if (parentField !== 0 && customField !== '') {
      const newurl = `${process.env.REACT_APP_NODE_URL}/api/master/add-custom-fieldnewmain`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      Axios.post(newurl, { parentField: parentField, customField: customField, CustomFieldTypeMain: CustomFieldTypeMain }, config)
        .then((response) => {
          if (response && response.data.isSuccess) {
            console.log(response.data.result, "add-custom-field");
            dispatch(setShowMessage(t.fieldcreated || "Field Created"));
            setParentField(0);
            setCustomField('');
            setAllowCustomField(false);

          }
        })
    } else {
      setErrorMessage(t.please_fill_required_fields || 'please fill all fields')
    }
  }


  function buildTree(data) {
    const idMapping = data.reduce((acc, el, i) => {
      acc[el.id] = i;
      return acc;
    }, {});
    let root = [];
    data.forEach(el => {
      if (el.resource_id === null) {
        root.push(el);
      } else {
        const parentEl = data[idMapping[el.resource_id]];
        parentEl.children = [...(parentEl.children || []), el];
      }
    });
    return root;
  }
  const HandleChangeParentFieldlist = async (parent) => {
    setMainparentField(parent);
    setTreedataList([]);
    getAllList(parent)
  }

  const getAllList = (mainparentField) => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/get-all-field-list-basedon-parent/${mainparentField}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    Axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          console.log(response.data.result, "treeeeeeeeeeeeeeedataaaaaaaaaaaaaaaaaaaaaa")
          if (response.data.result.length > 0) {
            const treeData = buildTree(response.data.result);
            setTreedataList(treeData)
            console.log(treeData, "treeeeeeeeeeeeeeedataaaaaaaaaaaaaaaaaaaaaa@@@@@@@@@@@@@@@@@@@@")
          }
        }
      }
    });
  }
  useEffect(() => {
    getMainField();
  }, [])
  // Tree Node Component
  const TreeNode = ({ node }) => {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [childName, setChildName] = useState('');
    const [CustomFieldType, setCustomFieldType] = useState(0);


    const handleToggleForm = () => {
      setIsFormVisible(!isFormVisible);
    };
    const handleDeleteField = async (node) => {
      console.log(node, "node...................on delete")
      const url = `${process.env.REACT_APP_NODE_URL}/api/master/delete-custom-field/${node.id}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      await Axios.get(url, config).then((response) => {
        if (response.data && response.data.isSuccess) {
          console.log(response.data);
          dispatch(setShowMessage(t.fielddeleted || "Custom field Deleted"));
          getAllList(node.category_main_field_id)
        } else {
          dispatch(setShowMessage(t.fielddeletefailed || "failed to delete"));
        }
      });
    }
    const handleSubmit = (e) => {
      e.preventDefault();
      if (childName.trim()) {
        onAddChild(node.id, childName, node.resource_id, node.category_main_field_id, CustomFieldType);
        setChildName('');
        setCustomFieldType(0);
        setIsFormVisible(false);
      }
    };
    const onAddChild = (parentField, customField, resource_id, category_main_field_id, CustomFieldType) => {
      const newurl = `${process.env.REACT_APP_NODE_URL}/api/master/add-custom-fieldnew`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      Axios.post(newurl, { parentField: parentField, customField: customField, resource_id: resource_id, category_main_field_id: category_main_field_id, CustomFieldType: CustomFieldType }, config)
        .then((response) => {
          if (response && response.data.isSuccess) {
            console.log(response.data.result, "add-custom-field");
            dispatch(setShowMessage(t.childfieldcreated || "Child Field Created"));
            setMainparentField(category_main_field_id);
            getAllList(category_main_field_id)
          }
        })

    }
    return (
      <li className="mb-1 tree-node-item">
        <div className="d-flex justify-content-between">
          <span className="fs-5 fw-bold text-primary">{node.name}</span>
          <div>
            <button className='btn btn-outline-primary btn-sm ms-2' onClick={handleToggleForm} >
              +
            </button>
            <button className='btn btn-outline-danger btn-sm ms-2' onClick={() => handleDeleteField(node)}>

              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" /></svg>
            </button>
          </div>
        </div>
        {isFormVisible && (
          // <form onSubmit={handleSubmit} style={{ marginTop: '10px' }}>
          //   <input
          //     type="text"
          //     value={childName}
          //     onChange={(e) => setChildName(e.target.value)}
          //     placeholder="Child Name"
          //     required
          //   />
          //   <button className='btn btn-secondary btn-sm ms-1' type="submit">Add</button>
          //   <button className='btn btn-secondary btn-sm ms-1' onClick={() => { setIsFormVisible(false); }}>X</button>
          // </form>
          <Modal show={isFormVisible} onHide={() => { setIsFormVisible(false); }}>
            <Modal.Header closeButton>
              <h4 className="modal-title">
                {`${t.addfield} ${t.customfield}`}
              </h4>
            </Modal.Header>
            <Modal.Body>
              <form style={{ marginTop: '10px' }}>
                <div className="container">
                  <div className="row">
                    <input
                      type="text"
                      value={childName}
                      onChange={(e) => setChildName(e.target.value)}
                      placeholder={t.entercustomlabel || "Enter Field Name"}
                      className="form-control modal-input"
                      required
                    />
                  </div>
                  <div className="row mt-2 mb-2">
                    <select
                      onChange={(e) => setCustomFieldType(e.target.value)}
                      className="form-control modal-input"
                      name="fieldtype"
                      Value={CustomFieldType}
                    >
                      <option value={0}>{t.selectfieldtypeplaceholder || 'Select Field Type'}</option>
                      <option value={1}>{t.fieldtype_textbox || 'Text box'}</option>
                      <option value={2}>{t.fieldtype_selectbox || 'Select box'}</option>
                      <option value={3}>{t.fieldtype_checkbox || 'Checkbox'}</option>
                      <option value={4}>{t.fieldtype_radiobutton || 'Radio Button'}</option>
                      <option value={5}>{t.fieldtype_date || 'Date Box'}</option>
                    </select>
                  </div>
                  <div className="row mt-4">
                    <div className="d-flex justify-content-between">
                      <button
                        className="btn btn-danger modal-btn-cancel"
                        type="button"
                        onClick={() => { setIsFormVisible(false); }}
                      >
                        {t.cancel || 'Cancel'}
                      </button>
                      <button
                        className="btn btn-primary modal-btn-add px-4"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        {t.add || 'Add'}
                      </button>
                    </div>
                  </div>

                </div>

              </form>
            </Modal.Body>
          </Modal>
        )}
        {node.children && node.children.length > 0 && (
          <ul className="list-unstyled ms-4">
            {node.children.map(childNode => (
              <TreeNode key={childNode.id} node={childNode} onAddChild={onAddChild} />
            ))}
          </ul>
        )}

      </li>
    );
  };
  return (
    <>
      {/* <div className="addUser myBorder bg-white rounded p-3">
        <div className="row m-0">
          <div className="col-6">
            <h5 className="m-0">Add Custom Field</h5>
          </div>
        </div>
        {customFields && (
          <div className="d-flex flex-row flex-wrap col-12">
            {Array.isArray(customFields) &&
              customFields.map((field, index) => (
                <section className="d-flex mt-3 flex-row " key={index}>
                  <div className="d-flex flex-column">
                    <input
                      className="myLabel"
                      onChange={(e) => handleCustomFieldChange(index, e)}
                      placeholder="Enter Custom Field*"
                      style={{ border: "none", outline: "none" }}
                      type="text"
                      name="field"
                      value={field.field}
                    />
                    <input
                      onChange={(e) => handleCustomFieldChange(index, e)}
                      className="myInput inputElement"
                      placeholder="Enter Custom Label"
                      autoComplete="false"
                      type="text"
                      name="label"
                      value={field.label}
                    />
                  </div>
                  {index === customFields.length - 1 ? (
                    <div className="mx-3 my-3 ">
                      <Button
                        className="btn-lg "
                        variant="dark rounded-circle"
                        onClick={addCustomField}
                      >
                        +
                      </Button>
                    </div>
                  ) : (
                    <div className="mx-3 my-3 ">
                      <Button
                        className="btn-lg "
                        variant="danger rounded-circle"
                        onClick={() => removeCustomField(index)}
                      >
                        -
                      </Button>
                    </div>
                  )}
                </section>
              ))}
          </div>
        )}

        <section className="d-flex mt-3 flex-column flex-sm-row">
          <button
            className="col-12 col-sm-5 col-lg-2 myBtn py-2"
            onClick={handleSubmit}
            type="button"
          >
            Add Field
          </button>
        </section>
      </div> */}
      <div className="addUser bg-light border rounded p-4 shadow-sm">
        <div className="row m-0 mb-3">
          <div className="col-12">
            <h3 className="m-0 text-primary fw-bold">{`${t.addfield} ${t.customfield}`}</h3>
          </div>
        </div>

        <div className="d-flex flex-row flex-wrap col-12">
          {/* Parent Field Section */}
          <div className="d-flex flex-column me-3 mb-3 col-md-3">
            <label className="text-muted mb-1 fs-5">{`${t.selectparentfield}*`}</label>
            <select
              onChange={(e) => HandleChangeParentField(e)}
              className="form-select form-select-sm border-secondary shadow-sm"
              name="branchId"
              value={parentField}
            >
              <option value={0}>{t.selectparentfieldplaceholder || 'Select Parent Field'}</option>
              {mainFieldList &&
                mainFieldList.length > 0 &&
                mainFieldList.map((i, index) => (
                  <option key={index} value={i.id}>
                    {i.main_field_name}
                  </option>
                ))}
            </select>
          </div>

          {/* Custom Field Section */}
          <div className="d-flex flex-column me-3 mb-3 col-md-3">
            <label className="text-muted mb-1 fs-5">{`${t.entercustomlabel}*`}</label>
            <input
              onChange={(e) => { setCustomField(e.target.value); setErrorMessage('') }}
              className="form-control form-control-sm shadow-sm"
              placeholder={t.entercustomlabel || "Enter Custom Label"}
              autoComplete="off"
              type="text"
              name="label"
              disabled={!allowCustomField}
              value={customField}
            />
          </div>

          {/* Field Type Section */}
          <div className="d-flex flex-column me-3 mb-3 col-md-3">
            <label className="text-muted mb-1 fs-5">{`${t.selectfieldtype}*`}</label>
            <select
              onChange={(e) => setCustomFieldTypeMain(e.target.value)}
              className="form-select form-select-sm border-secondary shadow-sm"
              name="fieldtype"
              value={CustomFieldTypeMain}
              disabled={!allowCustomField}
            >
              <option value={0}>{t.selectfieldtypeplaceholder || 'Select Field Type'}</option>
              <option value={1}>{t.fieldtype_textbox || 'Text Box'}</option>
              <option value={2}>{t.fieldtype_selectbox || 'Select Box'}</option>
              <option value={3}>{t.fieldtype_checkbox || 'Checkbox'}</option>
              <option value={4}>{t.fieldtype_radiobutton || 'Radio Button'}</option>
              <option value={5}>{t.fieldtype_date || 'Date Box'}</option>
            </select>
          </div>
        </div>

        {/* Error Message Section */}
        <section>
          <span className="text-danger">{errorMessage}</span>
        </section>

        {/* Button Section */}
        <section className="d-flex flex-column flex-sm-row mt-4">
          <button
            className="btn btn-primary py-2 px-4 shadow-sm"
            onClick={SubmitHandler}
            type="button"
          >
            {t.addfield || 'Add Field'}
          </button>
        </section>
      </div>
      <div className="container custom-container">
        <h4 className="mt-4 custom-title fw-bold text-primary">{t.showallcustomfieldhint}</h4>
        <div className="form-group">
          <select
            onChange={(e) => HandleChangeParentFieldlist(e.target.value)}
            className="custom-select mb-3"
            name="branchId"
            Value={parentField}
          >
            <option value={0}>{t.selectparentfieldplaceholder || 'Select Parent Field'}</option>
            {mainFieldList &&
              mainFieldList.length > 0 &&
              mainFieldList.map((i, index) => {
                return (
                  <option
                    key={index}
                    value={i.id}
                    className="myLabel"
                  >
                    {i.main_field_name}
                  </option>
                );
              })}

          </select>
        </div>
        <div>
          <div className="custom-list ms-3">
            <ul className="list-group">
              {treedataList && treedataList.length > 0 && treedataList.map(node => (
                <TreeNode key={node.id} node={node} className="list-group-item" />
              ))}
            </ul>
          </div>
        </div>
      </div >
    </>
  );
};

export default CustomField;
